(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7e3oI", function(module, exports) {

$parcel$export(module.exports, "getIconPaths", () => $542c79ead65f1db4$export$66f32c9c70bb3715);
$parcel$export(module.exports, "iconNameToPathsRecordKey", () => $542c79ead65f1db4$export$9425a11d2baa1c9);
$parcel$export(module.exports, "IconSvgPaths16", () => (parcelRequire("lyZPJ")));
$parcel$export(module.exports, "IconSvgPaths20", () => (parcelRequire("adNjr")));
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $704DA = parcelRequire("704DA");

var $lyZPJ = parcelRequire("lyZPJ");

var $adNjr = parcelRequire("adNjr");

var $leH9B = parcelRequire("leH9B");
function $542c79ead65f1db4$export$66f32c9c70bb3715(name, size) {
    var key = (0, $704DA.pascalCase)(name);
    return size === (0, $leH9B.IconSize).STANDARD ? $lyZPJ[key] : $adNjr[key];
}
function $542c79ead65f1db4$export$9425a11d2baa1c9(name) {
    return (0, $704DA.pascalCase)(name);
}

});

})();
//# sourceMappingURL=allPaths.85801a31.js.map
